import flatten from 'lodash/flatten';
import isEmpty from 'lodash/isEmpty';
import { trimsAdapter } from '../apis/layoutServiceApi';
import { PaymentMethod } from '../reducers/financialCalculators';
import { sortPaymentMethods } from '../utils';
const returnIfNotEmpty = (value) => (isEmpty(value) ? undefined : value);
const getHasModelYearsArray = (model) => Array.isArray(model.model.modelYears) && model.model.modelYears.length > 0;
export const transformLayoutServiceModelResult = (data) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const hasModelYearsArray = getHasModelYearsArray(data);
    // response might have a single `modelYear` or an array of `modelYears`
    const modelYears = hasModelYearsArray ? data.model.modelYears || [] : [data.model.modelYear];
    const nameBadge = returnIfNotEmpty((_d = (_c = (_b = (_a = modelYears[0]) === null || _a === void 0 ? void 0 : _a.fields.modelYearPage) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.nameBadge) === null || _d === void 0 ? void 0 : _d.value);
    const sitecoreId = data.model.id;
    const defaultTrim = (_g = (_f = (_e = data.model.modelYear) === null || _e === void 0 ? void 0 : _e.fields.defaultTrim.fields) === null || _f === void 0 ? void 0 : _f.detKey) === null || _g === void 0 ? void 0 : _g.value;
    const trims = flatten(modelYears.map(modelYear => flatten((modelYear === null || modelYear === void 0 ? void 0 : modelYear.trims.map(trim => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        const foundMethods = (_c = (_b = (_a = trim === null || trim === void 0 ? void 0 : trim.fields) === null || _a === void 0 ? void 0 : _a.trimFilters) === null || _b === void 0 ? void 0 : _b.filter(item => Object.values(PaymentMethod).includes(item.name))) === null || _c === void 0 ? void 0 : _c.map(item => item.name);
        const availablePaymentMethods = sortPaymentMethods(foundMethods);
        const transmissions = trim.transmissions.map(transmission => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const exteriorColors = transmission.exteriorColors.map(color => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return ({
                    hexValue: (_a = color.fields.color.fields.hexValue) === null || _a === void 0 ? void 0 : _a.value,
                    colorName: (_b = color.fields.color.fields.colorName) === null || _b === void 0 ? void 0 : _b.value,
                    name: color.name,
                    key: (_c = color.fields.color.fields.detKey) === null || _c === void 0 ? void 0 : _c.value,
                    defaultInteriorColor: (_e = (_d = color.fields.defaultInteriorColor) === null || _d === void 0 ? void 0 : _d.fields.color.fields.detKey) === null || _e === void 0 ? void 0 : _e.value,
                    interiorColors: (_f = color.interiorColors) === null || _f === void 0 ? void 0 : _f.map(c => {
                        var _a, _b, _c, _d, _e;
                        return ({
                            name: c.name,
                            id: c.id,
                            hexValue: (_a = c.fields.color.fields.color.fields.hexValue) === null || _a === void 0 ? void 0 : _a.value,
                            colorName: (_b = c.fields.color.fields.color.fields.colorName) === null || _b === void 0 ? void 0 : _b.value,
                            key: (_c = c.fields.color.fields.color.fields.detKey) === null || _c === void 0 ? void 0 : _c.value,
                            image: (_d = c.fields.color.fields.color.fields.swatch) === null || _d === void 0 ? void 0 : _d.value,
                            colorCode: (_e = c.fields.sotId) === null || _e === void 0 ? void 0 : _e.value,
                        });
                    }),
                    trimImage: {
                        primaryImage: (_g = color.fields.primaryImage) === null || _g === void 0 ? void 0 : _g.value,
                        secondaryImage: (_h = color.fields.secondaryImage) === null || _h === void 0 ? void 0 : _h.value,
                    },
                });
            });
            return {
                transmissionKey: (_a = transmission.fields.detKey) === null || _a === void 0 ? void 0 : _a.value,
                id: transmission.id,
                modelCode: (_b = transmission.fields.modelCode) === null || _b === void 0 ? void 0 : _b.value,
                detIdentifier: (_c = transmission.fields.detIdentifier) === null || _c === void 0 ? void 0 : _c.value,
                transmissionName: (_d = transmission.fields.transmissionName) === null || _d === void 0 ? void 0 : _d.value,
                exteriorColorKey: (_f = (_e = transmission.fields.defaultExteriorColor) === null || _e === void 0 ? void 0 : _e.fields.color.fields.detKey) === null || _f === void 0 ? void 0 : _f.value,
                interiorColorKey: (_h = (_g = transmission.fields.defaultExteriorColor) === null || _g === void 0 ? void 0 : _g.fields.defaultInteriorColor.fields.color.fields.detKey) === null || _h === void 0 ? void 0 : _h.value,
                exteriorColors,
            };
        });
        return {
            modelSitecoreId: sitecoreId,
            trimGtmName: trim.name,
            modelGtmName: data.model.name,
            modelName: (_d = data.model.fields.modelName) === null || _d === void 0 ? void 0 : _d.value,
            modelYear: modelYear.name,
            modelKey: (_e = data.model.fields.detKey) === null || _e === void 0 ? void 0 : _e.value,
            trimName: trim.fields.trimName.value,
            trimKey: (_f = trim.fields.detKey) === null || _f === void 0 ? void 0 : _f.value,
            defaultTransmission: (_g = trim.fields.defaultTransmission.fields.detKey) === null || _g === void 0 ? void 0 : _g.value,
            transmissions,
            trimImage: {
                primaryThumbnail: (_h = trim.fields.primaryThumbnail) === null || _h === void 0 ? void 0 : _h.value,
                secondaryThumbnail: (_j = trim.fields.secondaryThumbnail) === null || _j === void 0 ? void 0 : _j.value,
            },
            detIdentifier: (_k = trim.fields.detIdentifier) === null || _k === void 0 ? void 0 : _k.value,
            compareTrimKeyFeatures: (_l = trim.fields.compareTrimKeyFeatures) === null || _l === void 0 ? void 0 : _l.value,
            trimFeaturesPageUrl: (_o = (_m = trim.fields.trimFeaturesPageUrl) === null || _m === void 0 ? void 0 : _m.value) === null || _o === void 0 ? void 0 : _o.href,
            videoUrl: (_p = trim.fields.videoUrl) === null || _p === void 0 ? void 0 : _p.value,
            bodyType: (_q = trim.fields.bodyType) === null || _q === void 0 ? void 0 : _q.map(bodyType => bodyType.name),
            // FIXME: update logic to get bodytype filter from filterCategory
            filters: { allFilters: (_r = trim.fields.trimFilters) === null || _r === void 0 ? void 0 : _r.map(filter => filter.name) },
            availablePaymentMethods,
            excludeFromInventory: (_t = (_s = trim.fields.excludeFromInventory) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : false,
            // retrieve the exclusion from model year then from the trim
            provincesExcludedForBap: {
                items: [
                    ...((_u = modelYear.fields.provincesExcludedForBap) !== null && _u !== void 0 ? _u : []),
                    ...((_v = trim.fields.provincesExcludedForBap) !== null && _v !== void 0 ? _v : []),
                ],
            },
        };
    })) || [])));
    return {
        trims: trimsAdapter.addMany(trimsAdapter.getInitialState(), trims),
        nameBadge,
        defaultTrim,
    };
};
export const transformLayoutServiceTransmissionApiResult = (data) => {
    var _a, _b, _c, _d;
    const transmission = data === null || data === void 0 ? void 0 : data.transmission;
    const nameBadge = (_a = transmission.model.fields.nameBadge) === null || _a === void 0 ? void 0 : _a.value;
    const modelName = (_b = transmission.model.fields.modelName) === null || _b === void 0 ? void 0 : _b.value;
    const exteriorColors = transmission.exteriorColors.map(color => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        const interiorColors = color.interiorColors.map(interiorColor => {
            var _a, _b, _c, _d, _e;
            return ({
                name: interiorColor.name,
                sitecoreId: interiorColor.id,
                hexValue: (_a = interiorColor.fields.color.fields.color.fields.hexValue) === null || _a === void 0 ? void 0 : _a.value,
                colorName: (_b = interiorColor.fields.color.fields.color.fields.colorName) === null || _b === void 0 ? void 0 : _b.value,
                key: (_c = interiorColor.fields.color.fields.color.fields.detKey) === null || _c === void 0 ? void 0 : _c.value,
                image: (_d = interiorColor.fields.color.fields.color.fields.swatch) === null || _d === void 0 ? void 0 : _d.value,
                colorCode: (_e = interiorColor.fields.sotId) === null || _e === void 0 ? void 0 : _e.value,
            });
        });
        return {
            hexValue: (_d = (_c = (_b = (_a = color === null || color === void 0 ? void 0 : color.fields) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.hexValue) === null || _d === void 0 ? void 0 : _d.value,
            colorName: (_h = (_g = (_f = (_e = color === null || color === void 0 ? void 0 : color.fields) === null || _e === void 0 ? void 0 : _e.color) === null || _f === void 0 ? void 0 : _f.fields) === null || _g === void 0 ? void 0 : _g.colorName) === null || _h === void 0 ? void 0 : _h.value,
            key: (_m = (_l = (_k = (_j = color === null || color === void 0 ? void 0 : color.fields) === null || _j === void 0 ? void 0 : _j.color) === null || _k === void 0 ? void 0 : _k.fields) === null || _l === void 0 ? void 0 : _l.detKey) === null || _m === void 0 ? void 0 : _m.value,
            defaultInteriorColor: (_t = (_s = (_r = (_q = (_p = (_o = color === null || color === void 0 ? void 0 : color.fields) === null || _o === void 0 ? void 0 : _o.defaultInteriorColor) === null || _p === void 0 ? void 0 : _p.fields) === null || _q === void 0 ? void 0 : _q.color) === null || _r === void 0 ? void 0 : _r.fields) === null || _s === void 0 ? void 0 : _s.detKey) === null || _t === void 0 ? void 0 : _t.value,
            name: color === null || color === void 0 ? void 0 : color.name,
            interiorColors,
        };
    });
    return {
        id: transmission.id,
        modelCode: (_d = (_c = transmission === null || transmission === void 0 ? void 0 : transmission.fields) === null || _c === void 0 ? void 0 : _c.modelCode) === null || _d === void 0 ? void 0 : _d.value,
        modelName,
        exteriorColors,
        assetIds: transmission.exteriorColors.map(color => {
            var _a, _b, _c;
            return ({
                exteriorKey: (_a = color.fields.color.fields.detKey) === null || _a === void 0 ? void 0 : _a.value,
                exteriorSitecoreId: (_b = color.fields.studioAssets) === null || _b === void 0 ? void 0 : _b.id,
                exteriorThreeSixtySitecoreId: (_c = color.fields.threeSixtyAssets) === null || _c === void 0 ? void 0 : _c.id,
                interiorColors: color.interiorColors.map(interiorColor => {
                    var _a, _b, _c;
                    return ({
                        key: (_a = interiorColor.fields.color.fields.color.fields.detKey) === null || _a === void 0 ? void 0 : _a.value,
                        sitecoreId: (_b = interiorColor.fields.color.fields.studioAssets) === null || _b === void 0 ? void 0 : _b.id,
                        threeSixtySitecoreId: (_c = interiorColor.fields.color.fields.threeSixtyAssets) === null || _c === void 0 ? void 0 : _c.id,
                    });
                }),
            });
        }),
        trimName: transmission.trim.fields.trimName.value,
        name: transmission.fields.transmissionName.value,
        detKey: transmission.fields.detKey.value,
        detIdentifier: transmission.fields.detIdentifier.value,
        nameBadge,
        defaultExteriorColor: transmission.fields.defaultExteriorColor.fields.color.fields.detKey.value,
        defaultInteriorColor: transmission.fields.defaultExteriorColor.fields.defaultInteriorColor.fields.color.fields.detKey.value,
        provincesExcludedForBap: {
            items: transmission.trim.fields.provincesExcludedForBap,
        },
    };
};
export const transformLayoutServiceApiAssetsResult = (data) => {
    var _a;
    const assets = (_a = data.studioAssets) === null || _a === void 0 ? void 0 : _a.children.map(asset => ({
        id: asset.id,
        src: asset.fields.src,
        alt: asset.fields.Alt.value,
        height: asset.fields.Height.value,
        width: asset.fields.Width.value,
    }));
    return assets;
};
// We retain much of the LayoutService structure because
// src/ThreeSixtyView JSS component is tightly coupled to the data structure
export const parseThreeSixtyAssets = (data, type) => {
    var _a, _b;
    try {
        if (!data) {
            // eslint-disable-next-line no-console
            console.warn(`No data in ${type} 360 assets API response`);
            return undefined;
        }
        // API returns an object with a message key if there is an error,
        // so we return undefined and hope the consuming components are happy with that
        if (data.message) {
            // eslint-disable-next-line no-console
            console.warn(`Error parsing ${type} 360 assets`, data.message);
            return undefined;
        }
        return {
            ...data,
            Large: {
                ...data.Large,
                children: [
                    ...data.Large.assets.map((asset) => ({
                        ...asset,
                        ...asset.fields,
                        alt: asset.fields.Alt,
                        url: asset.fields.src,
                    })),
                ],
            },
            Panoramic: {
                ...data.Panoramic,
                children: [
                    ...(((_b = (_a = data === null || data === void 0 ? void 0 : data.Panoramic) === null || _a === void 0 ? void 0 : _a.assets) === null || _b === void 0 ? void 0 : _b.map((asset) => ({
                        ...asset,
                        ...asset.fields,
                        alt: asset.fields.Alt,
                        url: asset.fields.src,
                    }))) || []),
                ],
            },
            Small: {
                ...data.Small,
                children: [
                    ...data.Small.assets.map((asset) => ({
                        ...asset,
                        ...asset.fields,
                        alt: asset.fields.Alt,
                        url: asset.fields.src,
                    })),
                ],
            },
        };
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Error parsing 360 assets', error);
    }
};
export const transformLayoutServiceThreeSixtyResult = (response) => ({
    exterior: parseThreeSixtyAssets(response === null || response === void 0 ? void 0 : response.threeSixtyAssets.exterior[0], 'exterior'),
    interior: parseThreeSixtyAssets(response === null || response === void 0 ? void 0 : response.threeSixtyAssets.interior[0], 'interior'),
});
export const transformLayoutServiceRecommendVehicles = (response) => {
    const recommendedVehicles = response.map(vehicle => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return ({
            modelKey: (_a = vehicle.Model) === null || _a === void 0 ? void 0 : _a.detKey,
            modelYear: (_b = vehicle.ModelYear) === null || _b === void 0 ? void 0 : _b.year,
            trimKey: (_c = vehicle.Trim) === null || _c === void 0 ? void 0 : _c.detKey,
            transmissionKey: (_d = vehicle.Transmission) === null || _d === void 0 ? void 0 : _d.detKey,
            exteriorColorKey: (_e = vehicle.ExteriorColor) === null || _e === void 0 ? void 0 : _e.color.detKey,
            interiorColorKey: (_f = vehicle.InteriorColor) === null || _f === void 0 ? void 0 : _f.color.detKey,
            exteriorColorName: (_h = (_g = vehicle.ExteriorColor) === null || _g === void 0 ? void 0 : _g.color) === null || _h === void 0 ? void 0 : _h.colorName,
            interiorColorName: (_k = (_j = vehicle.InteriorColor) === null || _j === void 0 ? void 0 : _j.color) === null || _k === void 0 ? void 0 : _k.colorName,
            modelName: (_l = vehicle.Model) === null || _l === void 0 ? void 0 : _l.modelName,
            trimName: (_m = vehicle.Trim) === null || _m === void 0 ? void 0 : _m.trimName,
            trimGtmName: (_o = vehicle.Trim) === null || _o === void 0 ? void 0 : _o.name,
            transmissionName: (_p = vehicle.Transmission) === null || _p === void 0 ? void 0 : _p.transmissionName,
            inventoryStatus: (_q = vehicle.Inventory) === null || _q === void 0 ? void 0 : _q.status,
            trimImage: (_r = vehicle.ExteriorColor) === null || _r === void 0 ? void 0 : _r.primaryImage,
            bodyStyle: (_t = (_s = vehicle.VehicleType) === null || _s === void 0 ? void 0 : _s[0]) !== null && _t !== void 0 ? _t : '',
        });
    });
    return recommendedVehicles;
};
